import { fromJS } from 'immutable';

import { ApiSmartMarketing,UserToken } from '../../../helper/HelperAuth'
import {GetSenderSetting} from '../../constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (body) => async (dispatch) => {

    const Authorization = UserToken;
    const url = ApiSmartMarketing + 'result-report';

    //debugger
    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(body)
    };
    //debugger
    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS(await response.json());
        // data = data.get('query-result');
    }
    //debugger
    dispatch({ type: GetSenderSetting, data: fromJS(data) });
    
    // Return data untuk digunakan di component
    return data;
   
};